import "./LoaderSearch.scss";

export interface IPageLoader {
    customClass?: string
}

export default function LoaderSearchPages({ customClass }: IPageLoader) {
    return (
        <div className={`page-loader-search page-loader-search--active ${customClass || ''}`} />
    )
}
